import type { ReactNode } from "react";

interface TableToolbarProps {
	/** Left-aligned controls (search, status/type filters). */
	filters?: ReactNode;
	/** Right-aligned controls (action buttons). */
	actions?: ReactNode;
	className?: string;
}

/**
 * Toolbar row placed above a table: filters on the left, actions on the right.
 * Standardizes filter placement (currently scattered: inline, in table title, etc.).
 */
export function TableToolbar({ filters, actions, className }: TableToolbarProps) {
	return (
		<div className={`flex flex-wrap items-center justify-between gap-3 mb-3 ${className ?? ""}`}>
			<div className="flex flex-wrap items-center gap-2">{filters}</div>
			{actions ? <div className="flex items-center gap-2">{actions}</div> : null}
		</div>
	);
}
